import type { UserReport } from "../types/reports";

export interface ReportCollections {
  createdByMe: UserReport[];
  subscribed: UserReport[];
  sharedWithMe: UserReport[];
}

export function partitionReports(
  reports: UserReport[],
  currentUserId?: string,
): ReportCollections {
  return reports.reduce<ReportCollections>((collections, report) => {
    if (report.owner?.id === currentUserId) {
      collections.createdByMe.push(report);
    } else if (report.is_subscribed) {
      collections.subscribed.push(report);
    } else {
      collections.sharedWithMe.push(report);
    }
    return collections;
  }, { createdByMe: [], subscribed: [], sharedWithMe: [] });
}
